import { Component } from '@angular/core';
import { OutlookSkeletonLineComponent } from './skeleton-line.component';

@Component({
  selector: 'maximizer-outlook-skeleton-attendee-item',
  template: `
    <div class="flex items-center gap-2 p-1.5">
      <maximizer-outlook-skeleton
        containerClasses="h-8 w-8 max-w-8 rounded-sm bg-neutral-20"
        fullWidth="none"
      ></maximizer-outlook-skeleton>
      <div class="flex flex-col flex-1 gap-1 min-w-0">
        <maximizer-outlook-skeleton
          containerClasses="h-4 w-1/2 rounded bg-neutral-20"
        ></maximizer-outlook-skeleton>
        <maximizer-outlook-skeleton
          containerClasses="h-3 w-3/4 rounded bg-neutral-20"
        ></maximizer-outlook-skeleton>
        <maximizer-outlook-skeleton
          containerClasses="h-3 w-1/4 rounded bg-neutral-20"
        ></maximizer-outlook-skeleton>
      </div>
      <maximizer-outlook-skeleton
        containerClasses="h-6 w-6 max-w-6 rounded bg-neutral-20"
        fullWidth="none"
      ></maximizer-outlook-skeleton>
    </div>
  `,
  imports: [OutlookSkeletonLineComponent],
})
export class OutlookSkeletonAttendeeItemComponent {}
